import { codeSplit } from "bernie-core";
import { FlexComponentMap, ImportReactComponent } from "./typings";

export const flexComponentMap: FlexComponentMap = (new Map() as FlexComponentMap)
  .set("region", {
    aliases: [
      "region_wizard",
      "region_FullWidthWizard",
      "region_FullWidthBreadcrumbs",
      "region_FullWidthConfidenceMessages",
      "region_CallToActionGroup",
      "region_all-b-padding-three",
      "region_all-cell-1-3",
      "region_dx-sidebar-content",
      "region_dx-page-header",
      "region_dx-main-content",
      "region_dx-page-content",
      "region_SEO links",
      "region_CenteredDestinationWizard",
      "region_NoBackgroundConfidenceMessages",
      "region_RecentlyBookedReviewedNoBorderBkg",
      "region_NativeShowcase",
      "region_Weekend Getaways",
      "region_PropertyHeroImage",
      "region_PropertyReviewHeadline",
      "region_EdgePaddingWrapper",
      "region_HeroEditorial",
      "region_banner_ad_1",
      "region_geo_hotels_1",
    ],
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-region" */ "components/flexComponents/SimpleContainer/SimpleContainer"
        ) as ImportReactComponent
    ),
  })
  .set("region_centered-content-container", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-region_centered-content-container" */ "components/flexComponents/CenteredContentRegion/CenteredContentRegion"
        ) as ImportReactComponent
    ),
  })
  .set("region_storefront-wizard", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-region_storefront-wizard" */ "components/flexComponents/WizardPWARegions/StorefrontWizardRegion/StorefrontWizardRegion"
        ) as ImportReactComponent
    ),
  })
  .set("region_storefront-wizard-bex", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-region_storefront-wizard-bex" */ "src/components/flexComponents/WizardPWARegions/StorefrontWizardRegionBEX/StorefrontWizardRegionBEX"
        ) as ImportReactComponent
    ),
  })
  .set("region_storefront-wizard-taap", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-region_storefront-wizard-taap" */ "src/components/flexComponents/WizardPWARegions/StorefrontWizardRegionTAAP/StorefrontWizardRegionTAAP"
        ) as ImportReactComponent
    ),
  })
  .set("region_storefront-wizard-comet", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-region_storefront-wizard-comet" */ "src/components/flexComponents/WizardPWARegions/StorefrontWizardRegionCOMET/StorefrontWizardRegionCOMET"
        ) as ImportReactComponent
    ),
  })
  .set("region_centralized-wizard", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-region_centralized-wizard" */ "components/flexComponents/WizardPWARegions/CentralizedWizardRegion/CentralizedWizardRegion"
        ) as ImportReactComponent
    ),
  })
  .set("region_wizard-hotwire", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-region_wizard-hotwire" */ "components/flexComponents/WizardPWARegions/WizardRegionHotwire/WizardRegionHotwire"
        ) as ImportReactComponent
    ),
  })
  .set("region_cta-carousel", {
    aliases: ["region_lob-carousel", "region_grid-merch-container"],
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-region_cta-carousel" */ "components/flexComponents/CTACarouselRegion/CTACarouselRegion"
        ) as ImportReactComponent
    ),
  })
  .set("region_mobile-confidence-messages-carousel", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-region_mobile-confidence-messages-carousel" */ "components/flexComponents/MobileConfidenceMessagesCarouselRegion/MobileConfidenceMessagesCarouselRegion"
        ) as ImportReactComponent
    ),
  })
  .set("region_wizard-background-image-or-color", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-region_wizard-background-image-or-color" */ "components/flexComponents/WizardBackgroundImageOrColorRegion/WizardBackgroundImageOrColorRegion"
        ) as ImportReactComponent
    ),
  })
  .set("region_multi-column", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-region_multi-column" */ "components/flexComponents/MultiColumnContainer/MultiColumnContainer"
        ) as ImportReactComponent
    ),
  })
  .set("region_affinity-container", {
    aliases: ["region_affinity-full-width", "region_affinity-image"],
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-region_affinity-container" */ "src/components/flexComponents/AffinityRegion/AffinityRegion"
        ) as ImportReactComponent
    ),
  })
  .set("region_two-buttons", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-region_two-buttons" */ "src/components/flexComponents/TwoButtonsRegion/TwoButtonsRegion"
        ) as ImportReactComponent
    ),
  })
  .set("breadcrumbs", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-breadcrumbs" */ "components/flexComponents/Breadcrumbs/Breadcrumbs"
        ) as ImportReactComponent
    ),
  })
  .set("breadcrumbs-v2", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-breadcrumbs-v2" */ "src/components/flexComponents/Breadcrumbs/shared-ui/Breadcrumbs"
        ) as ImportReactComponent
    ),
  })
  .set("call-to-action", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-call-to-action" */ "components/flexComponents/CallToAction/CallToAction"
        ) as ImportReactComponent
    ),
  })
  .set("check-prices", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-check-prices" */ "components/flexComponents/CheckPrices/CheckPrices"
        ) as ImportReactComponent
    ),
  })
  .set("cross-lob-links", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-cross-lob-links" */ "components/flexComponents/CrossLOBLinks/CrossLOBLinks"
        ) as ImportReactComponent
    ),
  })
  .set("destination-attractions", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-destination-attractions" */ "components/flexComponents/DestinationAttractions/DestinationAttractions"
        ) as ImportReactComponent
    ),
  })
  .set("destination-description", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-destination-description" */ "components/flexComponents/DestinationDescription/views/DefaultDestinationDescription"
        ) as ImportReactComponent
    ),
  })
  .set("destination-description_cgs", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-destination-description_cgs" */ "components/flexComponents/DestinationDescription/views/HtmlDestinationDescription"
        ) as ImportReactComponent
    ),
  })
  .set("destination-discovery-map", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-destination-discovery-map" */ "components/flexComponents/DestinationDiscoveryMap/DestinationDiscoveryMap"
        ) as ImportReactComponent
    ),
  })
  .set("destination-hero", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-destination-hero" */ "components/flexComponents/DestinationHero/DestinationHero"
        ) as ImportReactComponent
    ),
  })
  .set("destination-neighborhoods", {
    aliases: ["te-neighborhood"],
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-destination-neighborhoods" */ "components/flexComponents/DestinationNeighborhoods/DestinationNeighborhoods"
        ) as ImportReactComponent
    ),
  })
  .set("destination-suggestions", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-destination-suggestions" */ "components/flexComponents/DestinationSuggestions/DestinationSuggestions"
        ) as ImportReactComponent
    ),
  })
  .set("destination-user-reviews", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-destination-user-reviews" */ "components/flexComponents/DestinationUserReviews/DestinationUserReviews"
        ) as ImportReactComponent
    ),
  })
  .set("editorial", {
    aliases: ["dynamic-vendor-content"],
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-editorial" */ "components/flexComponents/Editorial/Content"
        ) as ImportReactComponent
    ),
  })
  .set("frequently-asked-questions", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-frequently-asked-questions" */ "components/flexComponents/Faq/Faq"
        ) as ImportReactComponent
    ),
  })
  .set("frequently-asked-questions-v2", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-frequently-asked-questions-v2" */ "components/flexComponents/Faq/shared-ui/Faq"
        ) as ImportReactComponent
    ),
  })
  .set("hotel-recent-reviews", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-hotel-recent-reviews" */ "components/flexComponents/HotelRecentReviews/HotelRecentReviews"
        ) as ImportReactComponent
    ),
  })
  .set("hotel-recent-reviews_view", {
    aliases: ["hotel-recent-reviews_thumbnail-image-left-card", "hotel-recent-reviews_header-image-card"],
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-hotel-recent-reviews_view" */ "components/flexComponents/HotelRecentReviews/views/HotelRecentReviewsView"
        ) as ImportReactComponent
    ),
  })
  .set("hotels", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-hotels" */ "components/flexComponents/Hotels/Hotels"
        ) as ImportReactComponent
    ),
  })
  .set("hotels_carousel", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-hotels_carousel" */ "components/flexComponents/Hotels/views/ViewCarousel"
        ) as ImportReactComponent
    ),
  })
  .set("hotels_travellers-loved", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-hotels_travellers-loved" */ "components/flexComponents/Hotels/views/TravelersLovedHotels"
        ) as ImportReactComponent
    ),
  })
  .set("hotels_summarized-hotels", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-hotels_summarized-hotels" */ "src/components/flexComponents/Hotels/views/SummarizedHotels"
        ) as ImportReactComponent
    ),
  })
  .set("hotels_summarized-hotels-carousel", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-hotels_summarized-hotels-carousel" */ "src/components/flexComponents/Hotels/views/SummarizedHotelsCarousel"
        ) as ImportReactComponent
    ),
  })
  .set("hotels_summarized-hotels-carousel-top-image", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-hotels_summarized-hotels-carousel-top-image" */ "src/components/flexComponents/Hotels/views/SummarizedHotelsCarouselTopImage"
        ) as ImportReactComponent
    ),
  })
  .set("jumplinks", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-jumplinks" */ "components/flexComponents/Jumplinks/Jumplinks"
        ) as ImportReactComponent
    ),
  })
  .set("links", {
    component: codeSplit(
      () =>
        import(/* webpackChunkName: "blossom-links" */ "components/flexComponents/Links/Links") as ImportReactComponent
    ),
  })
  .set("links_card-carousel", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-links_card-carousel" */ "components/flexComponents/Links/views/CardsCarouselLinksView"
        ) as ImportReactComponent
    ),
  })
  .set("maps", {
    aliases: ["maps_dynamic"],
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-maps" */ "components/flexComponents/Maps/MapsViews"
        ) as ImportReactComponent
    ),
  })
  .set("maps_button", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-maps_button" */ "components/flexComponents/Maps/views/MapButton"
        ) as ImportReactComponent
    ),
  })
  .set("page-heading", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-page-heading" */ "components/flexComponents/PageHeading/PageHeading"
        ) as ImportReactComponent
    ),
  })
  .set("page-heading_wizard", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-page-heading_wizard" */ "components/flexComponents/PageHeading/view/PageHeadingWizard"
        ) as ImportReactComponent
    ),
  })
  .set("page-heading_property-filter-experience", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-page-heading_property-filter-experience" */ "components/flexComponents/PageHeading/view/PageHeadingFilterExperience"
        ) as ImportReactComponent
    ),
  })
  .set("recently-booked-hotels", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-recently-booked-hotels" */ "components/flexComponents/RecentlyBookedHotels/RecentlyBookedHotels"
        ) as ImportReactComponent
    ),
  })
  .set("recently-booked-hotels_view", {
    aliases: [
      "recently-booked-hotels_thumbnail-image-left-card-carousel",
      "recently-booked-hotels_full-bleed-image-card-carousel",
    ],
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-recently-booked-hotels_view" */ "components/flexComponents/RecentlyBookedHotels/views/RecentlyBookedHotelsView"
        ) as ImportReactComponent
    ),
  })
  .set("similar-destiations", {
    aliases: ["te-similar-destination"],
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-similar-destiations" */ "components/flexComponents/SimilarDestinations/SimilarDestinations"
        ) as ImportReactComponent
    ),
  })
  .set("top-cities", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-top-cities" */ "components/flexComponents/TopCities/TopCities"
        ) as ImportReactComponent
    ),
  })
  .set("trip-cost-estimator", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-trip-cost-estimator" */ "components/flexComponents/TripCostEstimator/TripCostEstimator"
        ) as ImportReactComponent
    ),
  })
  .set("te-neighborhood_neighborhood_with_dx_hsr", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-te-neighborhood_neighborhood_with_dx_hsr" */ "components/flexComponents/DestinationNeighborhoods/views/TopNeighborhoods"
        ) as ImportReactComponent
    ),
  })
  .set("te-neighborhood_carousel", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-te-neighborhood_carousel" */ "src/components/flexComponents/DestinationNeighborhoods/views/TopNeighborhoodsCarousel"
        ) as ImportReactComponent
    ),
  })
  .set("visitor-blogs", {
    aliases: ["te-article"],
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-visitor-blogs" */ "components/flexComponents/VisitorBlogs/VisitorBlogs"
        ) as ImportReactComponent
    ),
  })
  .set("wizard-hotel-pwa", {
    aliases: ["wizard"],
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-wizard-hotel-pwa" */ "components/flexComponents/WizardHotelPWA/WizardHotelPWAViews"
        ) as ImportReactComponent
    ),
  })
  .set("ad", {
    component: codeSplit(
      () => import(/* webpackChunkName: "blossom-ad" */ "components/flexComponents/Ad/Ad") as ImportReactComponent
    ),
  })
  .set("tab-group", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-tab-group" */ "components/flexComponents/TabGroup/TabGroup"
        ) as ImportReactComponent
    ),
  })
  .set("tab", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-tab" */ "src/components/flexComponents/TabContents/TabContents"
        ) as ImportReactComponent
    ),
  })
  .set("link-juice", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-link-juice" */ "components/flexComponents/LinkJuice/LinkJuice"
        ) as ImportReactComponent
    ),
  })
  .set("destination-where-to-stay", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-destination-where-to-stay" */ "components/flexComponents/DestinationWhereToStay/DestinationWhereToStay"
        ) as ImportReactComponent
    ),
  })
  .set("wizard-car-pwa", {
    aliases: ["wizard-gt-pwa"],
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-wizard-car-pwa" */ "components/flexComponents/WizardCarPWA/WizardCarPWA"
        ) as ImportReactComponent
    ),
  })
  .set("wizard-lx-pwa", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-wizard-lx-pwa" */ "components/flexComponents/WizardLXPWA/WizardLXPWA"
        ) as ImportReactComponent
    ),
  })
  .set("wizard-thirdPartyPackage-pwa", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-wizard-thirdPartyPackage-pwa" */ "components/flexComponents/Wizard3ppPWA/Wizard3ppPWA"
        ) as ImportReactComponent
    ),
  })
  .set("wizard-externalLinkTab-pwa", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-wizard-externalLinkTab-pwa" */ "components/flexComponents/WizardExternalLinkTabPWA/WizardExternalLinkTabPWA"
        ) as ImportReactComponent
    ),
  })
  .set("wizard-cruise-pwa", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-wizard-cruise-pwa" */ "components/flexComponents/WizardCruisePWA/WizardCruisePWA"
        ) as ImportReactComponent
    ),
  })
  .set("wizard-package-pwa", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-wizard-package-pwa" */ "components/flexComponents/WizardPackagePWA/WizardPackagePWA"
        ) as ImportReactComponent
    ),
  })
  .set("wizard-flight-pwa", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-wizard-flight-pwa" */ "components/flexComponents/WizardFlightPWA/WizardFlightPWA"
        ) as ImportReactComponent
    ),
  })
  .set("wizard-vr-pwa", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-wizard-vr-pwa" */ "src/components/flexComponents/WizardVRPWA/WizardVRPWA"
        ) as ImportReactComponent
    ),
  })
  .set("wizard-hotel-pwa-v2", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-wizard-hotel-pwa-v2" */ "components/flexComponents/WizardHotelPWAv2/WizardHotelPWAv2"
        ) as ImportReactComponent
    ),
  })
  .set("native-tile-showcase", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-native-tile-showcase" */ "components/flexComponents/NativeTileShowcase/NativeTileShowcase"
        ) as ImportReactComponent
    ),
  })
  .set("native-marquee-tile", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-native-marquee-tile" */ "components/flexComponents/NativeMarqueeTile/NativeMarqueeTile"
        ) as ImportReactComponent
    ),
  })
  .set("destination-video", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-destination-video" */ "components/flexComponents/DestinationVideo/DestinationVideo"
        ) as ImportReactComponent
    ),
  })
  .set("recently-viewed-hotels", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-recently-viewed-hotels" */ "components/flexComponents/RecentlyViewedHotels/RecentlyViewedHotels"
        ) as ImportReactComponent
    ),
  })
  .set("trip-attach-qualification", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-trip-attach-qualification" */ "components/flexComponents/TripAttachQualification/TripAttachQualification"
        ) as ImportReactComponent
    ),
  })
  .set("destination-cross-link", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-destination-cross-link" */ "components/flexComponents/DestinationCrossLink/DestinationCrossLink"
        ) as ImportReactComponent
    ),
  })
  .set("merch-campaigns", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-merch-campaigns" */ "src/components/flexComponents/MerchCampaign/MerchCampaign"
        ) as ImportReactComponent
    ),
  })
  .set("recently-viewed", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-recently-viewed" */ "components/flexComponents/RecentlyViewedWrapper/RecentlyViewedWrapper"
        ) as ImportReactComponent
    ),
  })
  .set("property-filters", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-property-filters" */ "components/flexComponents/PropertyFilters/PropertyFilters"
        ) as ImportReactComponent
    ),
  })
  .set("property-filters_pills", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-property-filters_pills" */ "components/flexComponents/PropertyFilters/views/PropertyFiltersPills"
        ) as ImportReactComponent
    ),
  })
  .set("region_property-filters-interactive", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-region_property-filters-interactive" */ "components/flexComponents/PropertyFiltersInteractive/PropertyFiltersInteractive"
        ) as ImportReactComponent
    ),
  })
  .set("property-filters_sort", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-property-filters_sort" */ "components/flexComponents/PropertyFilters/views/PropertyFiltersSort"
        ) as ImportReactComponent
    ),
  })
  .set("packaging", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-packaging" */ "components/flexComponents/Packages/Packages"
        ) as ImportReactComponent
    ),
  })
  .set("babaille-booking-cancellation", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-babaille-booking-cancellation" */ "components/flexComponents/BabailleBookingCancellation/BabailleBookingCancellation"
        ) as ImportReactComponent
    ),
  })
  .set("babaille-booking-cancellation-terms", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-babaille-booking-cancellation-terms" */ "components/flexComponents/BabailleBookingCancellationTerms/BabailleBookingCancellationTerms"
        ) as ImportReactComponent
    ),
  })
  .set("property-gallery", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-property-gallery" */ "components/flexComponents/PropertyGallery/PropertyGallery"
        ) as ImportReactComponent
    ),
  })
  .set("property-summary", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-property-summary" */ "components/flexComponents/PropertySummary/PropertySummary"
        ) as ImportReactComponent
    ),
  })
  .set("property-summary_location-highlights", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-property-summary_location-highlights" */ "components/flexComponents/PropertySummary/views/PropertySummaryLocationHighlights"
        ) as ImportReactComponent
    ),
  })
  .set("property-summary_single-offer", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-property-summary_single-offer" */ "components/flexComponents/PropertySummary/views/PropertySummarySingleOffer"
        ) as ImportReactComponent
    ),
  })
  .set("property-whats-around", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-property-whats-around" */ "components/flexComponents/PropertyWhatsAround/PropertyWhatsAround"
        ) as ImportReactComponent
    ),
  })
  .set("property-filter-pills", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-property-filter-pills" */ "components/flexComponents/PropertyPillFilters/PropertyPillFilters"
        ) as ImportReactComponent
    ),
  })
  .set("property-amenity-description", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-property-amenity-description" */ "components/flexComponents/PropertyAmenityDescription/PropertyAmenityDescription"
        ) as ImportReactComponent
    ),
  })
  .set("property-faq", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-property-faq" */ "components/flexComponents/PropertyFaq/PropertyFaq"
        ) as ImportReactComponent
    ),
  })
  .set("property-similar-properties", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-property-similar-properties" */ "components/flexComponents/PropertySimilarProperties/PropertySimilarProperties"
        ) as ImportReactComponent
    ),
  })
  .set("property-navigation-bar", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-property-navigation-bar" */ "components/flexComponents/PropertyNavigationBar/PropertyNavigationBar"
        ) as ImportReactComponent
    ),
  })
  .set("property-policies", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-property-policies" */ "components/flexComponents/PropertyPolicies/PropertyPolicies"
        ) as ImportReactComponent
    ),
  })
  .set("property-about-this", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-property-about-this" */ "components/flexComponents/PropertyAboutThis/PropertyAboutThis"
        ) as ImportReactComponent
    ),
  })
  .set("property-important-info", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-property-important-info" */ "components/flexComponents/PropertyImportantInfo/PropertyImportantInfo"
        ) as ImportReactComponent
    ),
  })
  .set("property-special-features", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-property-special-features" */ "components/flexComponents/PropertySpecialFeatures/PropertySpecialFeatures"
        ) as ImportReactComponent
    ),
  })
  .set("property-offers", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-property-offers" */ "components/flexComponents/PropertyOffers/PropertyOffers"
        ) as ImportReactComponent
    ),
  })
  .set("property-single-offer", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-property-single-offer" */ "src/components/flexComponents/PropertyOffers/views/PropertySingleOffer"
        ) as ImportReactComponent
    ),
  })
  .set("property-reviews", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-property-reviews" */ "components/flexComponents/PropertyReviewsWrapper/PropertyReviewsWrapper"
        ) as ImportReactComponent
    ),
  })
  .set("property-reviews-headline", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-property-reviews-headline" */ "components/flexComponents/PropertyReviewsHeadline/PropertyReviewsHeadlineWrapper"
        ) as ImportReactComponent
    ),
  })
  .set("property-hero-image", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-property-hero-image" */ "components/flexComponents/PropertyHeroImage/PropertyHeroImageWrapper"
        ) as ImportReactComponent
    ),
  })
  .set("destination-nearest", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-destination-nearest" */ "components/flexComponents/DestinationNearest/DestinationNearest"
        ) as ImportReactComponent
    ),
  })
  .set("deals", {
    component: codeSplit(
      () =>
        import(/* webpackChunkName: "blossom-deals" */ "components/flexComponents/Deals/Deals") as ImportReactComponent
    ),
  })
  .set("separator", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-separator" */ "components/flexComponents/Separator/Separator"
        ) as ImportReactComponent
    ),
  })
  .set("region_native-ad-container", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-region_native-ad-container" */ "components/flexComponents/NativeAdContainerRegion/NativeAdContainerRegion"
        ) as ImportReactComponent
    ),
  })
  .set("loyalty-acquisition-banner", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-loyalty-acquisition-banner" */ "components/flexComponents/LoyaltyAcquisitionBanner/LoyaltyAcquisitionBanner"
        ) as ImportReactComponent
    ),
  })
  .set("hotels_view", {
    aliases: ["hotels_image-top", "hotels_image-left-small", "hotels_image-left-large", "hotels_image-half"],
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-hotels_view" */ "components/flexComponents/Hotels/views/HotelsViews/HotelsViews"
        ) as ImportReactComponent
    ),
  })
  .set("global-sitemap", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-global-sitemap" */ "components/flexComponents/GlobalSiteMaps/GlobalSiteMaps"
        ) as ImportReactComponent
    ),
  })
  .set("editorial_banner-v2", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-editorial_banner-v2" */ "components/flexComponents/EditorialBanner/EditorialBanner"
        ) as ImportReactComponent
    ),
  })
  .set("star-rating-links", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-star-rating-links" */ "components/flexComponents/StarRatingLinks/StarRatingLinks"
        ) as ImportReactComponent
    ),
  })
  .set("table", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-table" */ "components/flexComponents/TableFlexModule/TableFlexModule"
        ) as ImportReactComponent
    ),
  })
  .set("hotwire-deals", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-hotwire-deals" */
          "components/flexComponents/HotwireDeals/HotwireDeals"
        ) as ImportReactComponent
    ),
  })
  .set("region_native-tile-showcase", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-region_native-tile-showcase" */ "components/flexComponents/NativeTileShowcaseRegion/NativeTileShowcaseRegion"
        ) as ImportReactComponent
    ),
  })
  .set("region_nts-flex-item", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-region_nts-flex-item" */ "components/flexComponents/NativeTileShowcaseItemRegion/NativeTileShowcaseItemRegion"
        ) as ImportReactComponent
    ),
  })
  .set("coupons-content", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-coupons-content" */ "components/flexComponents/CouponTerms/CouponTerms"
        ) as ImportReactComponent
    ),
  })
  .set("region_biased-wizard", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-region_biased-wizard" */ "src/components/flexComponents/WizardPWARegions/StorefrontWizardRegionMeso/StorefrontWizardRegionMeso"
        ) as ImportReactComponent
    ),
  })
  .set("cookie-consent-toggle", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-cookie-consent-toggle" */ "components/flexComponents/CookieConsentToggle/CookieConsentToggle"
        ) as ImportReactComponent
    ),
  })
  .set("airport-address", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-airport-address" */ "components/flexComponents/AirportAddress/AirportAddress"
        ) as ImportReactComponent
    ),
  })
  .set("mad-marquee", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-mad-marquee" */ "components/flexComponents/MadMarquee/MadMarquee"
        ) as ImportReactComponent
    ),
  })
  .set("travel-advisor", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-travel-advisor" */ "components/flexComponents/TravelAdvisor/TravelAdvisor"
        ) as ImportReactComponent
    ),
  })
  .set("region_auth-container", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-region_auth-container" */ "components/flexComponents/AuthContainer/AuthContainer"
        ) as ImportReactComponent
    ),
  })
  .set("flights-structured-table", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-flights-structured-table" */ "components/flexComponents/FlightsStructuredTable/FlightsStructuredTable"
        ) as ImportReactComponent
    ),
  })
  .set("coupons", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-coupons" */ "src/components/flexComponents/Coupons/Coupons"
        ) as ImportReactComponent
    ),
  })
  .set("region_meso-collapsible-group", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-region_meso-collapsible-group" */ "src/components/flexComponents/MesoCollapsibleGroupRegion/MesoCollapsibleGroupRegion"
        ) as ImportReactComponent
    ),
  })
  .set("hotwire-marketing-banner", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-hotwire-marketing-banner" */ "src/components/flexComponents/HotwireMarketingBanner/HotwireMarketingBanner"
        ) as ImportReactComponent
    ),
  })
  .set("meso-native", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-meso-native" */ "components/flexComponents/FluidAd/FluidAd"
        ) as ImportReactComponent
    ),
  })
  .set("nearby-features", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-nearby-features" */ "components/flexComponents/NearbyFeatures/NearbyFeatures"
        ) as ImportReactComponent
    ),
  })
  .set("flights", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-flights" */ "components/flexComponents/Flights/Flights"
        ) as ImportReactComponent
    ),
  })
  .set("flights-review", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-flights-review" */ "components/flexComponents/FlightsReview/FlightsReview"
        ) as ImportReactComponent
    ),
  })
  .set("hotwire-email-subscription", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-hotwire-email-subscription" */ "components/flexComponents/HotwireEmailSubscription/HotwireEmailSubscription"
        ) as ImportReactComponent
    ),
  })
  .set("cars", {
    component: codeSplit(
      () => import(/* webpackChunkName: "blossom-cars" */ "components/flexComponents/Cars/Cars") as ImportReactComponent
    ),
  })
  .set("property-search-link", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-property-search-link" */ "components/flexComponents/PropertySearchLink/PropertySearchLink"
        ) as ImportReactComponent
    ),
  })
  .set("property-space-details", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-property-space-details" */ "components/flexComponents/PropertySpaceDetails/PropertySpaceDetails"
        ) as ImportReactComponent
    ),
  })
  .set("travel-advisory", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-travel-advisory" */ "components/flexComponents/TravelAdvisory/TravelAdvisory"
        ) as ImportReactComponent
    ),
  })
  .set("hotwire-affiliate-toast", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-hotwire-affiliate-toast" */ "components/flexComponents/HotwireAffiliateToast/HotwireAffiliateToast"
        ) as ImportReactComponent
    ),
  })
  .set("price-trend-graph", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-price-trend-graph" */ "components/flexComponents/PriceTrendGraph/PriceTrendGraph"
        ) as ImportReactComponent
    ),
  })
  .set("category-activities", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-category-activities" */ "components/flexComponents/CategoryActivities/CategoryActivities"
        ) as ImportReactComponent
    ),
  })
  .set("region_toggle", {
    aliases: ["region_expand-collapse-subregions"],
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-region_toggle" */ "components/flexComponents/ToggleContainer/ToggleContainer"
        ) as ImportReactComponent
    ),
  })
  .set("region_responsive-toggle", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-region_responsive-toggle" */ "components/flexComponents/ResponsiveToggleContainer/ResponsiveToggleContainer"
        ) as ImportReactComponent
    ),
  })
  .set("activities-by-category", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-activities-by-category" */ "components/flexComponents/ActivitiesByCategory/ActivitiesByCategory"
        ) as ImportReactComponent
    ),
  })
  .set("meso-ad-configuration-override", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-meso-ad-configuration-override" */ "components/flexComponents/MesoAdConfigurationOverride/MesoAdConfigurationOverride"
        ) as ImportReactComponent
    ),
  })
  .set("activities-by-point-of-interest", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-activities-by-point-of-interest" */ "components/flexComponents/ActivitiesByPointOfInterest/ActivitiesByPointOfInterest"
        ) as ImportReactComponent
    ),
  })
  .set("customer-notifications", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-customer-notifications" */ "components/flexComponents/CustomerNotificationsWrapper/CustomerNotificationsWrapper"
        ) as ImportReactComponent
    ),
  })
  .set("flights-schedule", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-flights-schedule" */ "components/flexComponents/FlightsSchedule/FlightsSchedule"
        ) as ImportReactComponent
    ),
  })
  .set("flights-flexible-search", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-flights-flexible-search" */ "src/components/flexComponents/FlightsFlexibleSearch/FlightsFlexibleSearch"
        ) as ImportReactComponent
    ),
  })
  .set("hw-maps", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-hw-maps" */ "components/flexComponents/HotwireMaps/HotwireMaps"
        ) as ImportReactComponent
    ),
  })
  .set("mock-component", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-mock-component" */ "components/flexComponents/MockComponent/MockComponent"
        ) as ImportReactComponent
    ),
  })
  .set("cr-supplier-address", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-cr-supplier-address" */ "components/flexComponents/CarVendorAddress/CarVendorAddress"
        ) as ImportReactComponent
    ),
  })
  .set("travel-advisor-map", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-travel-advisor-map" */ "components/flexComponents/TravelAdvisorMap/TravelAdvisorMap"
        ) as ImportReactComponent
    ),
  })
  .set("info-cards", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-info-cards" */ "components/flexComponents/InfoCards/InfoCards"
        ) as ImportReactComponent
    ),
  })
  .set("background-image-override", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-background-image-override" */ "components/flexComponents/BackgroundImageOverride/BackgroundImageOverride"
        ) as ImportReactComponent
    ),
  })
  .set("cr-interlinking", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-cr-interlinking" */ "components/flexComponents/Interlinking/Interlinking"
        ) as ImportReactComponent
    ),
  })
  .set("cr-reviews", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-cr-reviews" */ "components/flexComponents/CarReviews/CarReviews"
        ) as ImportReactComponent
    ),
  })
  .set("region_meso-ad-group", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-region_meso-ad-group" */ "src/components/flexComponents/MesoAdGroupRegion/MesoAdGroupRegion"
        ) as ImportReactComponent
    ),
  })
  .set("editorial_banner-hero", {
    aliases: ["editorial_banner-hero-v2"],
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-editorial_banner-hero" */ "components/flexComponents/EditorialHeroBanner/EditorialHeroBanner"
        ) as ImportReactComponent
    ),
  })
  .set("twitter-embed", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-twitter-embed" */ "components/flexComponents/TwitterEmbed/TwitterEmbed"
        ) as ImportReactComponent
    ),
  })
  .set("region_spacing-container", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-region_spacing-container" */ "components/flexComponents/SpacingContainer/SpacingContainer"
        ) as ImportReactComponent
    ),
  })
  .set("title-container", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-title-container" */ "components/flexComponents/TitleContainer/TitleContainer"
        ) as ImportReactComponent
    ),
  })
  .set("social-media-sharing", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-social-media-sharing" */ "components/flexComponents/SocialMediaSharing/SocialMediaSharing"
        ) as ImportReactComponent
    ),
  })
  .set("region_view-port-container", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-region_view-port-container" */ "components/flexComponents/ViewPortContainer/ViewPortContainer"
        ) as any
    ),
  })
  .set("cruise-messaging-card", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-cruise-messaging-card" */ "components/flexComponents/CruiseMessagingCard/CruiseMessagingCard"
        ) as ImportReactComponent
    ),
  })
  .set("rewards-banner", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-rewards-banner" */ "components/flexComponents/RewardsBanner/RewardsBanner"
        ) as ImportReactComponent
    ),
  })
  .set("dated-searches", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-dated-searches" */ "components/flexComponents/DatedSearches/DatedSearches"
        ) as ImportReactComponent
    ),
  })
  .set("pre-bundled-packages-carousel", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-pre-bundled-packages-carousel" */ "components/flexComponents/PreBundledPackagesCarousel/PreBundledPackagesCarousel"
        ) as ImportReactComponent
    ),
  })
  .set("property-unit-list-view", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-property-unit-list-view" */ "components/flexComponents/PropertyUnitListView/PropertyUnitListView"
        ) as ImportReactComponent
    ),
  })
  .set("lodging-search-form", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-lodging-search-form" */ "components/flexComponents/LodgingSearchForm/LodgingSearchForm"
        ) as ImportReactComponent
    ),
  })
  .set("cruise-sailing-search-button", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-cruise-sailing-search-button" */ "components/flexComponents/CruiseSailingSearchButton/CruiseSailingSearchButton"
        ) as ImportReactComponent
    ),
  })
  .set("property-amenities-simplified-view", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-property-amenities-simplified-view" */ "components/flexComponents/PropertyAmenitiesSimplifiedView/PropertyAmenitiesSimplifiedView"
        ) as ImportReactComponent
    ),
  })
  .set("region_full-background-container", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-region_full-background-container" */ "components/flexComponents/FullBackgroundRegion/FullBackgroundRegion"
        ) as ImportReactComponent
    ),
  })
  .set("wizard-enforce-login-pwa", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-wizard-enforce-login-pwa" */ "components/flexComponents/EnforceUserSignIn/EnforceUserSignIn"
        ) as ImportReactComponent
    ),
  })
  .set("cruise-product-listings", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-cruise-product-listings" */ "components/flexComponents/CruiseProductListings/CruiseProductListings"
        ) as ImportReactComponent
    ),
  })
  .set("property-whats-around-pois-view", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-property-whats-around-pois-view" */ "components/flexComponents/PropertyWhatsAroundPoisView/PropertyWhatsAroundPoisView"
        ) as ImportReactComponent
    ),
  })
  .set("paperform", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-paperform" */ "components/flexComponents/Paperform/Paperform"
        ) as ImportReactComponent
    ),
  })
  .set("incentives-collection", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-incentives-collection" */ "components/flexComponents/IncentivesCollection/IncentivesCollection"
        ) as ImportReactComponent
    ),
  })
  .set("property-relevant-amenities", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-property-relevant-amenities" */ "components/flexComponents/PropertyRelevantAmenities/PropertyRelevantAmenities"
        ) as ImportReactComponent
    ),
  })
  .set("incentives-journey", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-incentives-journey" */ "components/flexComponents/IncentivesJourney/IncentivesJourney"
        ) as ImportReactComponent
    ),
  })
  .set("vip-messaging", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-vip-messaging" */ "components/flexComponents/VipMessaging/VipMessaging"
        ) as ImportReactComponent
    ),
  })
  .set("flight-search-form", {
    component: codeSplit(
      () =>
        import(
          /* webpackChunkName: "blossom-flight-search-form" */ "components/flexComponents/FlightSearchForm/FlightSearchForm"
        ) as ImportReactComponent
    ),
  });
